
    import "src/app/AppSeller/SettingsPage/PickupAddress/Components/AddressCard/index.module.scss?farm_css_modules";
    
    export default {"active": `active-e413b284`,"address": `address-e413b284`,"addressCard": `addressCard-e413b284`,"addressId": `addressId-e413b284`,"content": `content-e413b284`,"options": `options-e413b284`,"warehouseName": `warehouseName-e413b284`}
    